<script>
	import {mapGetters} from 'vuex'
	import {ui, logout} from '@/js/firebase'

	export default {
		name: '',
		data() {
			return {
				componentName: '',
				ready: false,
			}
		},
		components: {},
		props: [],
		computed: {
			...mapGetters(['account']),
		},
		methods: {
			popLogin(anon) {
				console.log('POP', this.$refs.login)
				ui(this.$refs.login, anon)
			},
			logout,
		},
		mounted() {
			// Called after the instance has just been mounted where el is replaced by the newly created vm.el. If the root instance is mounted to an in-document element, vm.el will also be in-document when mounted is called.
			this.$nextTick(() => {
				this.ready = true
				// console.log('<> is ready and attached to the dom', this)
			})
		},
	}
</script>
<!-- ******************************************************************* -->
<template>
	<div v-show="ready" class="text-align-center">
		<v-btn @click="popLogin(false)">Register / Login</v-btn>
		<v-btn @click="popLogin(true)">Login as a guest</v-btn>
		<v-btn @click="logout">Logout</v-btn>
		<div v-show="!account">
			<p class="text-align-center">
				Please sign in so that we know who is running the test
			</p>
			<p>
				If this is your first time here the act of signing in will create your
				account
			</p>
			<div ref="login"></div>
		</div>
		<div v-show="account">
			<p class="text-align-center">
				You are already logged in. Click "Start Test" to continue
			</p>
		</div>
	</div>
</template>
<!-- ******************************************************************* -->
<style scoped></style>
